import { ToastContext } from 'contexts'
import { useContext, useRef } from 'react'

export const useHandleResponseError = () => {
    const { setToast } = useContext(ToastContext)

    const handleResponseError = async (res: Response, callBack?: () => void) => {
        if (!res.ok) {
            const data = await res.json()

            const url = res.status === 402 ? '/billing' : ''

            const linkLabel = res.status === 402 ? 'go to Billing' : ''

            let description = 'Something went wrong. Please try again.'

            if (res.status === 402) {
                description = data?.detail
            } else if (typeof data?.detail === 'string') {
                description = data?.detail
            } else if (typeof data?.detail?.[0]?.msg === 'string') {
                description = `${data.detail[0].msg.slice(0, 50)}...`
            } else if (res.status === 429) {
                description = 'Monthly rate limit exceeded'
            } else if (res.status === 401) {
                description = 'Access denied for this subnet'
            } else if (res.status === 500) {
                description = 'Internal server error'
            }

            setToast({
                message: description,
                type: 'negative',
                open: true,
                url: url,
                linkLabel: linkLabel,
            })

            callBack?.()

            return
        }
    }

    return { handleResponseError }
}

export const handleStreamingResponse = (
    response: any,
    setMessages: (text: string) => void,
    onDone?: () => void,
) => {
    const reader: any = response.body.getReader()

    let text = ''

    new ReadableStream({
        start(controller) {
            function push() {
                reader.read().then(({ done, value }: any) => {
                    if (done) {
                        controller.close()

                        onDone?.()

                        return
                    }

                    const token = new TextDecoder('utf-8').decode(value)
                    text += token

                    setMessages(text)

                    controller.enqueue(value)
                    push()
                })
            }
            push()
        },
    })

    return {
        text,
    }
}

export const applyDefaults = (values: any, defaults: any) => {
    return Object.keys(defaults).reduce((acc, key) => {
        acc[key] =
            values[key] === null ||
            values[key] === undefined ||
            values[key] === '' ||
            (Array.isArray(values[key]) && values[key].length === 0)
                ? defaults[key]
                : values[key]
        return acc
    }, {} as any)
}

export const useAbortController = () => {
    const abortControllerRef = useRef<AbortController | null>(null)

    const createAbortController = () => {
        abortControllerRef.current = new AbortController()
        return abortControllerRef.current.signal
    }

    const abort = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort()
            abortControllerRef.current = null
        }
    }

    return { createAbortController, abort, abortControllerRef }
}
